import React, {useState} from "react";
import {gql, useQuery} from "@apollo/client";
import FilterToolbar from "../../../../ui/filters/FilterToolbar";
import Tools from "../../../../../Tools";

const EventsFilters = props => {
    const query = gql`
        query getFilters(
            $regions: [String!]
        ){
            regions: getRegions{
                id
                name
            }

            countries: getCountries(regions: $regions) {
                id
                name
            }
        }
    `;

    const [regions, setRegions] = useState([]);

    const variables = {
        regions: Tools.convertEmptyToNull(regions),
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables
    });

    const filterFormatter = filter => {
        if (!filter)
            return [];

        return filter.map(option => ({
            key: option.id,
            value: option.id,
            label: option.name,
        }))
    };

    const withSelectAll = (options, label = 'Select all') => options.length === 0 ? [] : [{key: 'all', value: 'all', label: label}, ...options];

    const config = [
        {
            placeholder: 'All Regions',
            name: 'regions',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.regions), 'Select all Regions'),
            onChange: options => setRegions(options.map(option => option.value)),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'All Countries',
            name: 'countries',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.countries), 'Select all Countries'),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'Search Matches, Leagues, Venue, Team...etc',
            name: 'search',
            type: 'search',
            align: 'right',
            span: {xs: 12, md: 6, lg: 3},
        },
    ];

    return (
        <FilterToolbar loading={loading} error={error} filters={config} size="sm" color="primary" onChange={props.onChange}/>
    );
};

export default EventsFilters;
